import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStoreService {
  get(key) {
    return localStorage.getItem(key);
  }

  set(key, val) {
    return localStorage.setItem(key, val);
  }

  unset(key) {
    return localStorage.removeItem(key);
  }
}
